import React from "react";
import styled, { keyframes } from "styled-components";

const Div = styled.div`
  .main label {
    margin: 5px 5px 5px 5px;
    padding: 5px;
    width: 5px;
    font-size: 2px;
    background-color: #0066ab;
    border-radius: 50%;
    position: relative;
  }

  .one {
    animation: myfirst 2s infinite;
    animation-direction: alternate;
  }
  .two {
    animation: myfirst 2s infinite;
    animation-direction: alternate;
    animation-delay: 0.2s;
  }
  .three {
    animation: myfirst 2s infinite;
    animation-direction: alternate;
    animation-delay: 0.5s;
  }
  @keyframes myfirst {
    0% {
      left: 0px;
      top: 0px;
    }
    25% {
      left: 0px;
      top: 6px;
    }
    50% {
      left: 0px;
      top: 0px;
    }
    75% {
      left: 0px;
      top: 6px;
    }
    100% {
      left: 0px;
      top: 0px;
    }
  }
`;
const CustomLoader = () => {
  return (
    <Div>
      <div className="main pb-2 w-full text-center">
        <label className="text-transparent	one">1</label>
        <label className="text-transparent	two">2</label>
        <label className="text-transparent	three">3</label>
      </div>
    </Div>
  );
};

export default CustomLoader;
